export interface DigitalBadge {
  id: number;
  template: DigitalBadgeTemplate
  onCredly: boolean;
  person: DigitalBadgePerson;
  issuedOn: Date;
}

export interface DigitalBadgeTemplate {
  id: number;
  name: string;
}

export interface DigitalBadgePerson {
  id: number;
  firstName: string;
  lastName: string;
}

// universal digital badge issue interface
export interface BadgeIssue {
  badgeType: string;
  event: string;
  personId: number;
  position?: string;
  skillName?: string;
  skillNumber?: string;
  member?: string;
  medal?: string;
}

// digital badge issue interface for competitors
export class competitorBadgeIssue implements BadgeIssue {
  badgeType: string;
  event: string;
  personId: number;
  position?: string;
  skillName?: string;
  skillNumber?: string;
  member?: string;
  medal?: string;

  constructor(personId: number, event: string, skillName: string, skillNumber: string, member: string, medal: string) {
    this.personId = personId;
    this.event = event;
    this.badgeType = 'result';
    this.skillName = skillName;
    this.skillNumber = skillNumber;
    this.member = member;
    this.medal = medal;
  }
}
